import React from 'react';
import './errorbox.scss';
import {IconCollection} from '../../utilities/iconimport';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export const ErrorBox = (props) =>{
  return (
    <section className="errorBox">
      <FontAwesomeIcon className="errorIcon" icon={IconCollection.infoCircle}/>
      <article className="errorText">
        <div>{props.children}</div>
      </article>
    </section>
  );
};
